import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal, { ModalHeader } from '../../../../../components/Modal/Modal';
import {
  EnumTransferOrderStep,
  findEnumById,
} from '../../../../../constants/enum';
import TransferOrderSelectBranch from './components/TransferOrderSelectBranch';
import TransferOrderConfirm from './components/TransferOrderConfirm';
import TransferOrderVerify from './components/TransferOrderVerify';
import TransferOrderError from './components/TransferOrderError';
import { stopTransferringOrder } from './actions';
import './TransferOrder.scss';
import { isEmpty } from '../../../../../utils/utils';

class TransferOrderModal extends Component {
  render() {
    const {
      transferredOrder,
      stepId,
      stopTransferringOrderConnect,
    } = this.props;
    const { description } = findEnumById(EnumTransferOrderStep, stepId) || {};

    return (
      <Modal
        withCloseButton
        withOverlay={false}
        isOpen={!isEmpty(transferredOrder)}
        onRequestClose={stopTransferringOrderConnect}
        className="modal-transfer-order"
      >
        <ModalHeader>{description}</ModalHeader>
        {stepId === EnumTransferOrderStep.SELECT_BRANCH.id && (
          <TransferOrderSelectBranch />
        )}
        {stepId === EnumTransferOrderStep.VERIFY_BRANCH.id && (
          <TransferOrderVerify />
        )}
        {stepId === EnumTransferOrderStep.TRANSFER_CONFIRM.id && (
          <TransferOrderConfirm />
        )}
        {stepId === EnumTransferOrderStep.TRANSFER_ERROR.id && (
          <TransferOrderError />
        )}
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  stepId: state.transferOrder.stepId,
  transferredOrder: state.transferOrder.transferredOrder,
});

const mapDispatchToProps = {
  stopTransferringOrderConnect: stopTransferringOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(TransferOrderModal);



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/TransferOrder/TransferOrderModal.jsx